import React from 'react';

// adds current year to copyright tagline at the end of the app
const Copyright = () => (
  <p id="copyright" className="bentonsanscond-n4">&copy; {new Date().getFullYear()} Boston Globe Media Partners, LLC</p>
);

export default Copyright;
